// src/redux/cardsSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../utils/Constants";

// Async thunk for fetching data
export const fetchbooknAsync = createAsyncThunk(
  "cards/fetchCards/book",
  async (payload) => {
    const token = localStorage.getItem("Token");
    const headers = {
      Authorization: token,
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
    };
    try {
      const response = await axios.post(
        `${BASE_URL}/v1/user/createNannyBooking`,
        payload,
        { headers }
      ); 
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

const booknSlice = createSlice({
  name: "bookNannyData",
  initialState: {
    data: null,
    loading: "idle",
    error: null,
  },
  reducers: {
    clearBookingData: (state) => {
      // Reset the data property to an empty array
      state.data = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchbooknAsync.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(fetchbooknAsync.fulfilled, (state, action) => {
        state.loading = "idle";
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchbooknAsync.rejected, (state, action) => {
        state.loading = "idle";
        state.error = action.error.message;
      });
  },
});
export const { clearBookingData } = booknSlice.actions;
export default booknSlice.reducer;
